import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function Success({ modal, setModal }) {
  // const [open, setOpen] = React.useState(false);
  const handleClose = () => setModal(false);
  // const { gotSuccess, setgotSuccess } = React.useContext(LandingPageContext)
  return (
    <div>
      <Modal
        open={modal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"

      >
        <Box sx={style}>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Congratulations your flight has been successfully booked! Happy Journey!
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}
